import type { FilterItem, FilterValue } from '../../types';

export type FilterItemWithState = FilterItem & { isChecked: boolean } & { isVisible: boolean };

export class FilterProcessor {
    private filterItems: FilterItemWithState[] = [];

    constructor(filterItems: FilterItem[]) {
        this.filterItems = FilterProcessor.appendIsChecked(filterItems);
    }

    static appendIsChecked(filterItems: FilterItem[]): FilterItemWithState[] {
        return filterItems.map((item) => ({
            ...item,
            isChecked: false,
            isVisible: true,
        }));
    }

    markAsChecked(selectedFilterValue: FilterValue): FilterProcessor {
        this.filterItems = this.filterItems.map((item) => ({
            ...item,
            isChecked: ([item.value, item.label] as FilterValue[]).includes(selectedFilterValue),
        }));

        return this;
    }

    putIsCheckedInFront(): FilterProcessor {
        const checkedItems = this.filterItems.filter((item) => item.isChecked);
        const uncheckedItems = this.filterItems.filter((item) => !item.isChecked);
        this.filterItems = [...checkedItems, ...uncheckedItems];

        return this;
    }

    hideOverflow(shortListLength: number, isShowFullList: boolean): FilterProcessor {
        this.filterItems = this.filterItems.map((item, index) => ({
            ...item,
            isVisible: index < shortListLength || isShowFullList,
        }));

        return this;
    }

    getItems(): FilterItemWithState[] {
        return this.filterItems;
    }
}
